import React from "react";
import "../../../../css/Turismo/turismo.css";
import "../../../../css/Turismo/jardin-lechuzas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faPhone, faUser } from "@fortawesome/free-solid-svg-icons";
import { faLeaf, faImage } from "@fortawesome/free-solid-svg-icons";

const imagenes = [
  {
    src: require("../../../img/Jardin/lagaña-de-perro.JPG"),
    alt: "Lagaña de perro",
    col: "col-12 col-md-12",
  },
  {
    src: require("../../../img/Jardin/lechuza.JPG"),
    alt: "Lechuza",
    col: "col-12 col-md-6",
  },
  {
    src: require("../../../img/Jardin/lechuza2.JPG"),
    alt: "Lechuza 2",
    col: "col-12 col-md-6",
  },
  {
    src: require("../../../img/Jardin/malvavisco.JPG"),
    alt: "Malvavisco",
    col: "col-12 col-md-4",
  },
  {
    src: require("../../../img/Jardin/lechuzas-en-cartel-de-oliva.JPG"),
    alt: "Lechuzas en cartel de Oliva",
    col: "col-12 col-md-8",
  },
  {
    src: require("../../../img/Jardin/cortarramas-en-espinillo.JPG"),
    alt: "Cortarramas en espinillo",
    col: "col-12 col-md-5",
  },
  {
    src: require("../../../img/Jardin/colibri-en-tumiñico.JPG"),
    alt: "Colibrí en tumiñico",
    col: "col-12 col-md-4",
  },
  {
    src: require("../../../img/Jardin/pirincho-en-espinilo.JPG"),
    alt: "Pirincho en espinillo",
    col: "col-12 col-md-3",
  },
];

const JardinLechuzas = () => (
  <div>
    <div
      className="jardin-lechuzas text-center"
      style={{
        backgroundImage: `url(${require("../../../img/Jardin/lechuza2.JPG")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "-100px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 400,
        marginBottom: 30,
      }}
    >
      <div className="jardin-lechuzas-overlay" />
    </div>
    <div className="container">
      <h4>
        <FontAwesomeIcon icon={faLeaf} className="icono-titulo" /> El Jardín de las lechuzas
      </h4>
      <p>
        Ante este escenario de pérdida de biodiversidad y capital cultural, vecinos y vecinas
        de la ciudad conformaron el grupo “Oliva con los pies en la tierra” con el objetivo de
        restaurar espacios verdes para recuperar los bosques del Espinal en el ámbito urbano y
        periurbano. En sus primeros pasos, este grupo comenzó a incorporar plantas nativas de la
        región en diferentes espacios verdes públicos. A finales de 2017, el grupo decidió
        focalizarse en un espacio verde asociado al Museo Nacional de Malvinas ubicado en el
        centro de la ciudad. En ese entonces, la vegetación de esta zona se cortaba con
        dezmalezadoras que no dejaban crecer más que pastos. Luego de las primeras
        plantaciones con árboles nativos, y gracias al cuidado continuo del grupo y la participación
        de vecinas y vecinos colaboradores, se formalizó un nombre para el espacio: “El Jardín de
        las lechuzas”. El lugar recibió este nombre debido a que allí nidificaban las simpáticas
        lechucitas de las vizcacheras (Aethene cunicularia), que celosamente custodiaban las
        entradas de sus nidos y las plantaciones. Tiempo después, este lugar dejó de ser
        intervenido con desmalezadoras, y el estrato bajo del bosque pudo prosperar.
      </p>
      <strong>
        <FontAwesomeIcon icon={faImage} className="icono-titulo" /> Imágenes de la flora y fauna del jardín
      </strong>
      <br />
      <br />
      <div className="row">
        {imagenes.map((img, idx) => (
          <section className={img.col} key={idx}>
            <div className="imagenes-jardin">
              <img src={img.src} alt={img.alt} />
            </div>
          </section>
        ))}
        <section className="col-12">
          <div className="informacion-jardin">
            <p>
              <FontAwesomeIcon icon={faInstagram} className="icono-red" />
              Instagram:{" "}
              <a href="https://www.instagram.com/el_jardin_de_las_lechuzas/?hl=es" target="_blank" rel="noopener noreferrer">
                Jardin de las lechuzas
              </a>
            </p>
            <p>
              <FontAwesomeIcon icon={faFacebook} className="icono-red" />
              Facebook:{" "}
              <a href="https://www.facebook.com/olivaplanta/?locale=es_LA" target="_blank" rel="noopener noreferrer">
                Oliva con los pies en la tierra
              </a>
            </p>
            <p style={{ textIndent: 0 }}>
              <FontAwesomeIcon icon={faUser} className="icono-contacto" /> Contacto: Nicolas Rocamundi{" "}
              <FontAwesomeIcon icon={faPhone} className="icono-contacto" /> 3513483100
              <br />
              <FontAwesomeIcon icon={faUser} className="icono-contacto" /> Maylen Turletto{" "}
              <FontAwesomeIcon icon={faPhone} className="icono-contacto" /> 3532403246
            </p>
            <div className="imagenes-finales">
              <img src={require("../../../img/Jardin/Oliva-2.png")} alt="Oliva" />
              <img src={require("../../../img/Jardin/logo-jardin.jpg")} alt="Logo Jardin" />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
);

export default JardinLechuzas;